<template>
  <div id="foot">
    <div class="foot-container">
      <div class="foot-container_top justify-between">
        <div class="container_top_logo pointer" @click="logoClick">
          <svg-icon iconName="logo-R" width="154px" height="32px" />
        </div>
        <div class="container_top_hotLine">
          <div class="hotLine">
            <div class="hotLine-text">Customer Service Hotline：</div>
            <div class="hotLine-phone">+86-400-6788-533</div>
          </div>
          <div class="email hotLine">
            <div class="hotLine-text">Customer Service Email：</div>
            <div class="hotLine-phone">service@phfund.com.cn</div>
          </div>
        </div>
        <div></div>
      </div>
      <div class="foot-container_line"></div>
      <div class="foot-container_bottom flex-col align-center">
        <div class="bottom-filing">
          Copyright 2024 Penghua Fund Management Co., Ltd. All Rights Reserved.
          IPv6 Enabled.
        </div>
        <div class="bottom-report">
          Address: 43/F,international Chamber of Commerce Tower,Fuhua Rd.3
          NO.168,CBD,Futian Dist.,Shenzhen, Guangdong Province, P.R.China
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Foot',
  data() {
    return {}
  },
  created() {},
  methods: {
    logoClick() {
      this.$router.gotoPage('/home')
    }
  }
}
</script>

<style lang="scss" >
#foot {
  height: 331px;
  width: 100%;
  position: relative;
  overflow: hidden;
  background: #ffffff;
  .foot-container {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    .foot-container_bottom {
      padding: 28px 13px;
      font-size: 14px;
      color: #666666;
      .bottom-report {
        margin-top: 8px;
      }
      .bottom-filing {
        //margin-top: 28px;
      }
    }
    .foot-container_line {
      width: 100%;
      height: 1px;
      opacity: 0.3;
      background: #ececec;
    }
    .foot-container_top {
      padding: 26px 0 32px 0;
      .container_top_logo {
        height: min-content;
      }
      .container_top_hotLine {
        margin-left: -174px;
        .email {
          margin-top: 32px;
        }
        .hotLine {
          margin-top: 32px;
          .hotLine-text {
            font-size: 14px;
            color: #000000;
          }
          .hotLine-phone {
            font-weight: 600;
            font-size: 24px;
            color: #000000;
            margin-top: 6px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/Foot.vue